export default "__VITE_ASSET__2fe11b55__"